import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import {MODAL_SHOW_DETAILS} from '../../actions/modal';
import DashboardTracker from "../../utils/trackers/DashboardTracker";
import TrackerManager from '../../utils/TrackerManager';
import './styles/modalReintento.css';
import Device from "../../devices/device";
import PipManager from '../../utils/pipManager/PipManager';
import Metadata from '../../requests/apa/Metadata';
import { setRandomTimeout } from '../../utils/Utils';
import { Resilence } from 'src/AAF/Resilence/main';


/*  - Si en props viene la propiedad errorCode y es usuario IPTV en STB, se utiliza el rediseño con un solo botón.
    - Si no viene dicha propiedad se mantienen textos anteriores y el diseño de 3 botones.
    - Actualmente el único flujo que incorpora rediseño (props.errorCode) es la modal "fallback"
    - Se realiza reintento luego de cierto tiempo aleatorio si el usuario no selecciona ningún botón (solo para modal "fallback" [props.isStartPlayFalled] */

const ModalReintento = (props) => {
  const isIPTVUser = Resilence.isPTVUSer();
  const isNewModal = props.errorCode && isIPTVUser;

  const defaultAsset = isNewModal ? Asset.get('alert_warning_generic_icon', '') : 'https://clarovideocdn6-a.akamaihd.net/pregeneracion//cms/apa/531eed59e4b050ea818ae755/ic_modal_error.png';
  const defaultTitle = '¡Ocurrió algo inesperado!';
  const defaultContent = 'Tuvimos un inconveniente al intentar obtener los datos<br>';

  let messageModal = isNewModal ? Translator.get(props.errorCode, "") || props.messageModal : props.messageModal;
  let content =  messageModal ? messageModal : `${Translator.get('msg_modal_retry', defaultContent)} ${props.url}`;

    //Se migró esta funcion al ModalWrapper
    //PipManager.closePIP(Device,false);

  //console.log('[APIERROR] ModalReintento > TrackerManager send ApiError ', props);

  
  let timeoutId;
  if(props.isStartPlayFalled && isNewModal) {
    const defaultTimeoutData = `{ "enable": true, "min_time_ms": 300000, "max_time_ms": 3600000,"interval_ms": 300000}`;
    const {enable, min_time_ms, max_time_ms, interval_ms} = JSON.parse(Metadata.get("notSupported_streaming_modal_config", defaultTimeoutData));
    if(enable === true || enable === "true")
    timeoutId = setRandomTimeout(() => props.handleClose(null, props.onRetry), min_time_ms, max_time_ms, interval_ms)
  }

  function handleClose(e, callback) {
    props.handleClose(e, callback);
    if(props.isStartPlayFalled && isNewModal) clearTimeout(timeoutId);
  }

  let ybrObject = {
    stackTrace: content,
    msg: 'api_error',
    url: props.url ? props.url : ''
  };

  // retry playing param se pone desde onResolveShowModal de AAFPlayerMain,
  // que indica un error de api al intentar playear
  if(typeof props.retryPlaying === 'object') {
    ybrObject.retryPlaying = Object.assign({}, props.retryPlaying);
  }

  let skipRetry = props.skipRetry === true;

  if(!skipRetry) TrackerManager.apiError(ybrObject);

    if(typeof props.setMetricsEvent === 'function'){
      const sendDimension=()=>{
        const payload=new AnalyticsDimensionSingleton().getPayload();
        props.setMetricsEvent(payload);
        props.setMetricsEvent({ type: 'executor'});
      };
      const sendMetric=()=>{
        props.setMetricsEvent({
          hitType: 'event',
          eventCategory: 'errores',
          eventAction: defaultTitle,
          eventLabel: content,
        });
        props.setMetricsEvent({type:'executor'});
        sendDimension();
      };
      sendMetric();
    }

    const p = {
      className: isNewModal ? 'retry-new' : 'retry',
      asset: isNewModal ? Asset.get(`${props.errorCode}_icon`, defaultAsset) : Asset.get('ic_modal_error', defaultAsset),
      title: isNewModal ? Translator.get(`${props.errorCode}_title`, defaultTitle) : Translator.get('ti_modal_retry', defaultTitle),
      handleBackKey: (e) => handleClose(e, props.onReject),
      buttons: isNewModal ? [
          {
              content: Translator.get(`${props.errorCode}_button`, 'Reintentar'),
              props: {onClick: (e) => handleClose(e, props.onRetry)},
          }
      ] : [
        {
            content: Translator.get('btn_modal_retry', 'Reintentar'),
            props: {onClick: (e) => handleClose(e, props.onRetry)}
        },
        {
            content: Translator.get('btn_modal_ok', 'Aceptar'),
            props: {onClick: (e) => {handleClose(e, props.onReject);}}
        },{
            content: Translator.get('btn_modal_ver_detalles', 'Ver detalles'),
            props:{
              onClick: (e) => {
                if(props && props.clearLoading && (typeof props.clearLoading == 'function')){
                  props.clearLoading();
                }
                props.handleSecondModal(e, MODAL_SHOW_DETAILS, {...props, content:content})
              },
            }
        }
      ],
      onClose: (e) => {
        handleClose(e, props.onReject)
      },
    } 
  
    if(isNewModal) {
      p.aafNewStyle = true,
      p.showLogo = true,
      p.buttonsAlign = "vertical",
      p.content = content
    }

    return <ModalWrapper {...p} />;
}

export default withOnClose(ModalReintento);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalReintento.jsx